/**
 * @license
 * Copyright Nico Schett. All Rights Reserved.
 *
 * Use of this source code is governed by an EUPL-1.2 license that can be found
 * in the LICENSE file at https://snek.at/license
 */

export type BridgeConfig = {
  specifications: {
    [key: string]: any;
  };
};

export default {
  specifications: {},
} as BridgeConfig;
